import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-4 mb-8 bg-red-50 rounded flex items-start text-red-600 shadow-lg mx-auto max-w-2xl"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "text-lg" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "fill-current w-5 pt-1",
        viewBox: "0 0 24 24"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z" })
    ])
], -1);
const _hoisted_3 = { class: "pl-4" };
const _hoisted_4 = { class: "text-red-800 font-semibold tracking-wider" };
const _hoisted_5 = { class: "list-disc list-outside pl-5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.errMsgs.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString($props.process) + "に失敗しました。 ", 1),
                _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.errMsgs, (msg, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "whitespace-pre-wrap"
                        }, _toDisplayString(msg), 1));
                    }), 128))
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
